<template>
    <div>
        <div slot="footer">
            <vs-row vs-justify="flex-start"><!--
              <vs-button
                color="danger"
                icon-pack="feather"
                icon="icon-trash"
                style="border-radius: 5px"
                @click="
                  activePromptDelete = true;
                  deletedItem = item;
                "
                v-b-tooltip.hover.bottom="'Cari Sil'"
              ></vs-button>-->
                <vs-button size="small" color="#708090" icon-pack="feather" icon="icon-shopping-bag"
                    style="border-radius: 5px" @click="routepazaryeriDetay()"
                    v-b-tooltip.hover.bottom="'Sipariş Detay'"></vs-button>
                <vs-button size="small" color="warning" icon-pack="feather" icon="icon-file" style="border-radius: 5px"
                    @click="routeLogList()" v-b-tooltip.hover.bottom="'Log kaydı'"></vs-button>
                <span v-b-tooltip.hover.bottom="isCompleted ? 'Faturası yazıldığından silinemez' : 'Sil'"
                    style="display: inline-block">
                    <vs-button size="small" color="danger" icon-pack="feather" icon="icon-trash"
                        style="border-radius: 5px" :disabled="isCompleted"
                        :style="isCompleted ? 'pointer-events: none' : ''"
                        @click="activePromptOderDelete = true"></vs-button>
                </span>
                <span v-b-tooltip.hover.bottom="isCompleted ? 'Geri Al' : 'Tamamlanmamış sipariş geri alınamaz'"
                    style="display: inline-block">
                    <vs-button size="small" color="#7a4ce6" icon-pack="feather" icon="icon-repeat"
                        style="border-radius: 5px" :disabled="!isCompleted"
                        :style="!isCompleted ? 'pointer-events: none' : ''"
                        @click="activePromptOderReturn = true"></vs-button>
                </span>
            </vs-row>
        </div>
        <vs-prompt color="danger" title="UYARI" acceptText="Siparişi sil" cancelText="Vazgeç" @accept="deleteOrder()"
            :active.sync="activePromptOderDelete"> Siparişi sildiğinizde tarafımıza kaydedilen tüm değerleri silinecektir.
            <p>İlgili pazaryerinden sipariş dumunu tekrar ilk duruma ayarlayıp sipariş çekme işlemini yapabilirsiniz.</p>
            <span class="text-danger">Silme işlemini onaylıyor musunuz ?</span>
        </vs-prompt>
        <vs-prompt color="danger" title="UYARI" acceptText="Siparişi geri al" cancelText="Vazgeç" @accept="returnOrder()"
            :active.sync="activePromptOderReturn">Geri alma işlemini onaylıyor musunuz ?
        </vs-prompt>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activePromptOderDelete: false,
            activePromptOderReturn: false,
        }
    },
    computed: {
        isCompleted() {
            return this.params.data && this.params.data.iscomplete === "completed";
        }
    },
    methods: {
        routepazaryeriDetay() {
            console.log(this.params.data);
            this.$root.$emit('invoiceButtonClick', this.params.data);
        },
        routeLogList(item) {

            this.$root.$emit("orderLogList", this.params.data);

        },
        deleteOrder(item) {
            this.$root.$emit("deleteOrderAll", this.params.data);
        },
        returnOrder(item) {
            this.$root.$emit("returnOrder", this.params.data);
        }
    }
}
</script>